import { render } from "./Device.vue?vue&type=template&id=518135dc"
import script from "./Device.vue?vue&type=script&lang=js"
export * from "./Device.vue?vue&type=script&lang=js"

import "./Device.vue?vue&type=style&index=0&id=518135dc&lang=stylus"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__